import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { GraphQLSubscribe } from '../utils/methods/graphql.subscribe';

@Injectable()
export class CreateBatchSubscription extends GraphQLSubscribe {
	override command: DocumentNode = gql`
		subscription OnCreateBatch {
			onCreateBatch {
				id
				alias
				name
				sourceId
				status
				productionStart
				errors {
					terminalId
					type
					message
				}
			}
		}
	`;
}
